import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Helpers } from '../../../helpers/helpers';
import { RenaultAnimationActionDetailDTO } from '../../../models/renault-animation-action-dto';
import { RenaultUserAnimationDataDTO } from '../../../models/renault-user-dto';
import { SharedService } from '../../../services/shared.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'animation-user-data',
  templateUrl: './animation-user-data.component.html',
  styleUrls: ['./animation-user-data.component.scss']
})

export class AnimationUserDataComponent implements OnInit {

  @Input() userModel: RenaultUserAnimationDataDTO;

  @Output() onUserChange = new EventEmitter<RenaultUserAnimationDataDTO>();

  dataform: FormGroup;
  provincesData: any;
  submitted = 0;

  constructor(private service: UserService,
    private sharedService: SharedService,
    private toastr: ToastrService,
    private helpers: Helpers) { }

  ngOnInit() {

    const that = this;

    this.loadData();

    this.dataform = new FormGroup({
      IdUser: new FormControl(null, [Validators.required]),
      Name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      Surname: new FormControl(null, [Validators.required, Validators.maxLength(250)]),
      EmailPersonal: new FormControl(null, [Validators.required, Validators.maxLength(250)]),
      PhonePersonal: new FormControl(null, [Validators.required, Validators.maxLength(20)]),
      Dni: new FormControl(null, [Validators.required, Validators.maxLength(20)]),
      Birthdate: new FormControl(null, [Validators.required]),
      Address: new FormControl(null, [Validators.required]),
      Location: new FormControl(null, [Validators.required, Validators.maxLength(200)]),
      Cp: new FormControl(null, [Validators.required, Validators.maxLength(5)]),
      IdProvince: new FormControl(null, [Validators.required]),
      LegalApproved: new FormControl(null),
      UserHasDataCompleted: new FormControl(null),
      UserAnimationRol: new FormControl(null),
    });

    setTimeout(function () {
      that.dataform.patchValue(that.userModel);
      if (that.userModel.Birthdate)
        that.dataform.get("Birthdate").patchValue(that.helpers.formatDate(that.userModel.Birthdate));
    }, 500);
  }

  loadData() {
    this.sharedService.getRenaultProvinces().subscribe(resp => {
      this.provincesData = resp;
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  updateBirthdate(fecha) {
    this.dataform.controls["Birthdate"].setValue(fecha);
  }

  save() {
    this.submitted = 1;
    if (this.dataform.invalid) return;
    this.userModel = this.dataform.value;

    this.userModel.Province = this.provincesData.find(x => x.value == this.userModel.IdProvince.toString()).label;

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...'
    });
    Swal.showLoading();
    this.putData();
  }

  putData() {
    this.service.putFromAnimation(this.userModel.IdUser, this.userModel).subscribe(resp => {
      this.toastr.success("Los datos se han actualizado correctamente");
      Swal.close();
      this.userModel.UserHasDataCompleted = true;
      this.onUserChange.emit(this.userModel);
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al actualizar',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

}
